import { render, staticRenderFns } from "./HousingAssignmentsPane.vue?vue&type=template&id=13bb4c1e&scoped=true&"
import script from "./HousingAssignmentsPane.vue?vue&type=script&lang=js&"
export * from "./HousingAssignmentsPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb4c1e",
  null
  
)

export default component.exports